import clsx from 'clsx';

type GridListProps<T> = {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  columns?: number;
  rows?: number;
  gap?: string;
  className?: string;
  itemClassName?: string;
};

export const GridList = <T,>({
  items,
  renderItem,
  gap = 'gap-6',
  className = '',
  itemClassName = '',
}: GridListProps<T>) => {
  return (
    <div
      className={clsx(
        'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
        gap,
        'w-full',
        className
      )}
    >
      {items.map((item, index) => (
        <div key={index} className={clsx('min-w-0', itemClassName)}>
          {renderItem(item, index)}
        </div>
      ))}
    </div>
  );
};
